import React from 'react';
import './Services.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClinicMedical, faUserMd, faBriefcaseMedical } from '@fortawesome/free-solid-svg-icons';

const services = [
  {
    icon: faClinicMedical,
    title: 'Urgent Care',
    description: 'Open 7 days a week for acute illnesses and injuries. No appointment needed.'
  },
  {
    icon: faUserMd,
    title: 'Primary Care',
    description: 'Scheduled visits for chronic conditions, preventive care, and follow-ups.'
  },
  {
    icon: faBriefcaseMedical,
    title: 'Occupational Health',
    description: 'Tailored services for employers and employees, including exams and injury care.'
  }
];

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="home-service-card" key={index}>
              <div className="service-icon">
                <FontAwesomeIcon icon={service.icon} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
